import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/index.css";
import "../src/App.css";
import "../src/components/Footer/Footer.css";
import "../src/components/QrStudio/QrStudio.css";
import "../src/components/style.css";
import "../src/Home.css";
import "../src/introduction.css";
import "../src/Navbar_main.css";
import "../src/NotFound.css";
import "../src/redesign/Redesign.css";
import "../src/redesign/ScanQrCodePage.css";
import "../src/redesign/StaticPagesRedesign.css";
import "../src/user/FeatureInfoDialog.css";
import "../src/user/NotifyDialog.css";
import "../src/user/styles.css";
import "../src/user/UnauthenticatedPopup.css";
import "../src/user/UserActionArea.css";

export default function NextApp({ Component, pageProps }) {
  return <Component {...pageProps} />;
}
